import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import { PropsWithChildren } from 'react'
import { useUserStore } from './store'


export type UserLoaderProps = PropsWithChildren<Partial<{

    mock: boolean

}>>


// as a module we separate loading the logged user from loading all the users, in case the first may be neeeded without the second.
// <Users> will chain them in common use case. there's some `waterfalling` here, but we need to know the user before making any other call anyway.

export const UserLoader = (props: UserLoaderProps) => {

    const { children } = props

    const store = useUserStore()

 
    const { content } = useRenderGuard({

        render: children,
        orRun: store.fetchAll
    })

    return content
}


